<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Accounts</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="add"
            @click="addAccount"
            color="danger"
            type="border"
            v-if="abilities.can('create', 'accounts')"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
          <v-select v-model="per_page" :options="size_per_page" />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="7"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="p-1">
            <span>Search companies: </span>
          </div>

          <AccountAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchCompany"
            :searchOn="'company_or_registration_no'"
            @event-name="handleChildEvent"
          ></AccountAutocomplete>
          <vs-icon
            class="pl-5 pointer"
            icon="cancel"
            @click="resetAccount"
            size="small"
          ></vs-icon>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->
        </vs-col>
      </vs-row>


      <vs-table
      stripe
      :sst="true"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
      v-model="selected"
      :total="totalItems"
      :data="accounts">


      <!-- <vs-table
        class="mb-10"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="accounts"
      > -->
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->

          <vs-th>Registration No.</vs-th>

          <vs-th sort-key="company_name">
            Company
        </vs-th>
        <vs-th>
          Switchboard
        </vs-th>
        <vs-th sort-key="revenue">
          Revenue
        </vs-th>
        <vs-th sort-key="no_of_employees">
          Employees
        </vs-th>
        <vs-th>
          Actions
        </vs-th>


      
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].company_registration_number">
              {{ data[indextr].company_registration_number }}
            </vs-td>
            <vs-td :data="data[indextr].company_name">
              {{ data[indextr].company_name }}
            </vs-td>
            <vs-td :data="data[indextr].phone">
              <template v-for="phone in data[indextr].phone">
                <template v-for="p_type in phone.phone_type">
                  <template v-if="phone.id == p_type.phone_id">
                    <template v-if="p_type.type == 'head_office_switchboard'">
                      <p class="p-2">
                        <span v-if="phone.checked_status == 'Registered'" class="tps-registered" style="font-size:20px;" title="TPS Registered">®</span> 

                        {{ phone.phone_code }}{{ phone.phone_no }}
                      </p>
                    </template>
                  </template>
                </template>
              </template>
            </vs-td>
            <vs-td :data="data[indextr].revenue" >
             <p v-if="data[indextr].revenue">{{ data[indextr].currency_name}} {{ data[indextr].revenue != 0? data[indextr].revenue:null}}</p>
            </vs-td>
              <vs-td :data="data[indextr].no_of_employees">
             <p>{{ data[indextr].no_of_employees != 0? data[indextr].no_of_employees:null}}</p>
            </vs-td>
            <vs-td :data="data[indextr].actions">
              <vs-icon size="18px" 
                v-if="abilities.can('read', 'accounts')"
                class="ml-10 removeButton"
                @click="viewAccount(data[indextr].id)"
                color="success"
                icon="visibility"
              ></vs-icon>
              <vs-icon size="18px" 
                v-if="abilities.can('update', 'accounts')"
                class="ml-10 removeButton"
                @click="editAccount(data[indextr].id)"
                color="success"
                icon="edit"
              ></vs-icon>
              <vs-icon size="18px" 
                v-if="abilities.can('delete', 'accounts')"
                class="ml-10 removeButton"
                @click="confirmDeleteAccount(data[indextr].id)"
                color="success"
                icon="delete"
              ></vs-icon>
            </vs-td>
            <template class="expand-user" slot="expand">
              <div class="con-expand-users">
                <table class="address_table">
                  <tr>
                    <td class="address_td"></td>
                    <th class="address_th" scope="col">Address 1</th>
                    <th class="address_th" scope="col">Address 2</th>
                    <th class="address_th" scope="col">Address 3</th>
                    <th class="address_th" scope="col">City</th>
                    <th class="address_th" scope="col">County</th>
                    <th class="address_th" scope="col">Postcode</th>
                    <th class="address_th" scope="col">Country</th>
                  </tr>
                  <tr>
                    <th class="address_th" scope="row">Head Office</th>
                    <td class="address_td">
                      {{ data[indextr].head_office_address_1 }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].head_office_address_2 }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].head_office_address_3 }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].head_office_city }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].head_office_county }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].head_office_postcode }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].head_office_country }}
                    </td>
                  </tr>
                  <tr>
                    <th class="address_th" scope="row">Registered Office</th>
                    <td class="address_td">
                      {{ data[indextr].registered_office_address_1 }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].registered_office_address_2 }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].registered_office_address_3 }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].registered_office_city }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].registered_office_county }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].registered_office_postcode }}
                    </td>
                    <td class="address_td">
                      {{ data[indextr].registered_office_country }}
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination :max="2"
          :total="Math.ceil(total / per_page)"
          v-model="currentx" 
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>


<script>
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import defineAbilitiesFor from "@/config/abilities.js";
import vSelect from "vue-select";
export default {
  data: () => ({
    sortedData: [],
      sortedbyASC: true,
    totalItems:10,
    abilities: null,
    companySearchComponentKey: 0,
    selected: [],
    log: [],
    accounts: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    sorting : {
      sortedby : 'desc',
      sortedkey : 'ml_id' 
    },
    paginationAttr: {
      page_no: 1,
      per_page: 10,
      length : 3
    }
  }),
  components: {
    AccountAutocomplete,
    "v-select": vSelect
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    }
  },
  methods: {
    handleSearch(searching) {
      let _print = `The user searched for: ${searching}\n`
      this.$refs.pre.appendChild(document.createTextNode(_print))
    },
    handleChangePage(page) {
      let _print = `The user changed the page to: ${page}\n`
      this.$refs.pre.appendChild(document.createTextNode(_print))
    },
    resetAccount() {
      this.fetchAccounts();
      this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      this.fetchAccounts();
    },
    searchCompany(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addAccount() {
      this.$router.push({ path: "accounts/add" });
    },
    handleSort(sortBy, active) {

    this.paginationAttr = {
      page_no: 1,
      per_page: 10,
      length : 3
    }

        this.sorting = {
          sortedby: active,
          sortedkey: sortBy
      };
      this.fetchAccounts();



      //   if (this.sortedbyASC) {
      //   this.accounts.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
      //   this.sortedbyASC = false;
      // } else {
      //   this.accounts.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
      //   this.sortedbyASC = true;
      // }
      // }
      
      
      
      // if(sortBy == 'revenue' || sortBy == 'no_of_employees'){
      //   if (this.sortedbyASC) {
      //   this.accounts.sort((x, y) => (parseInt(x[sortBy]) > parseInt(y[sortBy]) ? -1 : 1));
      //   this.sortedbyASC = false;
      // } else {
      //   this.accounts.sort((x, y) => (parseInt(x[sortBy]) < parseInt(y[sortBy]) ? -1 : 1));
      //   this.sortedbyASC = true;
      // }

      // }

 


      // alert("Dsdfsdfsdf")
      // console.log(`the user ordered: ${key} ${active}`);
    },
    viewAccount(id) {
      this.$router.replace("/accounts/" + id);
    },
    editAccount(id) {
      this.$router.replace("/accounts/edit/" + id);
    },
    handleChildEvent() {
      this.accounts = moduleAccountsManagement.state.accounts.datas;
      // console.log("Account" , this.accounts)
    },
    confirmDeleteAccount(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Account`,
        accept: this.deleteAccount,
        acceptText: "Delete"
      });
    },
    deleteAccount() {
      this.$store
        .dispatch("accountsManagement/removeAccount", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchAccounts();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Account Deleted",
        text: "The account was successfully deleted"
      });
    },
    fetchAccounts() {
      // console.log("pag" , this.sorting)
      let self = this
      let data = {}
      data.pagination = this.paginationAttr
      data.sorting = this.sorting
      this.$store
        .dispatch("accountsManagement/fetchAllAccountLists", data)
        .then(res => {
          self.accounts = res.data.datas;
          self.total = res.data.total;
          self.per_page = res.data.per_page;
          self.currentx = res.data.current_page;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
}},
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    this.fetchAccounts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
